import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlansService from "../../api/plans";


export const getPlans = createAsyncThunk(
  "plans/get",
  async (args, thunkAPI) => {
    try {
      const response = await PlansService.getPlans(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPlanDetail = createAsyncThunk(
  "planDetail/get",
  async (args, thunkAPI) => {
    try {
      const response = await PlansService.getPlanDetail(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createPlan = createAsyncThunk(
  "plans/post",
  async (args, thunkAPI) => {
    try {
      const response = await PlansService.createPlan(args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updatePlan = createAsyncThunk(
  "planDetail/put",
  async ({id, args}, thunkAPI) => {
    try {
      const response = await PlansService.updatePlan(id, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPlanLanguages = createAsyncThunk(
  "planlanguages/get",
  async (args, thunkAPI) => {
    try {
      const response = await PlansService.getPlanLanguages(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deletePlanVariant = createAsyncThunk(
  "planvariant/delete",
  async (id, thunkAPI) => {
    try {
      const response = await PlansService.deletePlanVariant(id);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  results: [],
  groupedResults: [],
  variants: [],
  count: 0,
  next: null,
  previous: null,
  selectedPlan: null,
  error: null,
  loading: false,
  loadingDetail: false,
  languages: [],
};

const plansByGroup = (arr = []) => {
  let result = [];
  result = arr.reduce((r, a) => {
     r[a.group?.name] = r[a.group?.name] || [];
     r[a.group?.name].push(a);
     return r;
  }, Object.create(null));
  return result;
};

const plansToVariants = (arr = []) => {
  let variants = []
  arr.map((plan) => {
    plan.variants.map((variant) => {
      variants.push(variant)
    })
  })
  return variants
}

const plansSlice = createSlice({
  name: "plans",
  initialState,
  extraReducers: {
    [getPlans.pending]: (state, action) => {
      state.loading = true;
    },
    [getPlans.fulfilled]: (state, action) => {
      Object.assign(state, action.payload);
      state.groupedResults = plansByGroup(action.payload.results);
      state.variants = plansToVariants(action.payload.results);
      state.loading = false;
    },
    [getPlans.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja áskriftarleiðir";
      state.loading = false;
    },
    [getPlanDetail.pending]: (state, action) => {
      state.loadingDetail = true;
    },
    [getPlanDetail.fulfilled]: (state, action) => {
      state.selectedPlan = action.payload;
      state.loadingDetail = false;
    },
    [getPlanDetail.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja áskriftarleið";
      state.loadingDetail = false;
    },
    [getPlanLanguages.pending]: (state, action) => {
      state.loading = true;
    },
    [getPlanLanguages.fulfilled]: (state, action) => {
      state.languages = action.payload;
      state.loading = false;
    },
    [getPlanLanguages.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja áskriftarleiðir";
      state.loading = false;
    },
  },
});

const { reducer } = plansSlice;
export default reducer;